import React from "react";

const ActionButton = ({ options, active, onChange, btnColor }) => {
  const theme = localStorage.getItem("theme");
  return (
    <div
      className="d-flex justify-content-start align-items-center"
      style={{ margin: "10px 0" }}
    >
      {options.map((label) => (
        <div style={{ marginRight: "20px" }}>
          <p
            style={{
              cursor: "pointer",
              color: active === label?.value ? "var(--text-color)" : "",
              borderBottom:
                active === label?.value ? `2px solid ${btnColor}` : "none",
              paddingBottom: "5px",
              marginBottom: 0,
            }}
            onClick={() => onChange(label?.value)}
          >
            {label?.label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default ActionButton;
